import { BrandColors } from "@/constants/theme";
import { isCustomerRole } from "@/lib/roles";
import { useAuthStore } from "@/stores/use-auth-store";
import Ionicons from "@react-native-vector-icons/ionicons";
import { router } from "expo-router";
import React from "react";
import {
  StyleProp,
  StyleSheet,
  TouchableOpacity,
  ViewStyle,
} from "react-native";
import { ThemedText } from "../themed-text";

export function RecoveryButton({ style }: { style?: StyleProp<ViewStyle> }) {
  const activeBooking = useAuthStore((state: any) => state.activeBooking);
  const user = useAuthStore((state: any) => state.user);
  const isCustomer = isCustomerRole(user?.role);

  if (!activeBooking) {
    return null;
  }

  const handleClick = () => {
    if (isCustomer) {
      router.push(`/bookings/${activeBooking}/live-tracking`);
    } else {
      router.push(`/bookings/${activeBooking}/live-driving`);
    }
  };

  return (
    <TouchableOpacity style={[styles.button, style]} onPress={handleClick}>
      <ThemedText style={styles.label}>Return to Recovery</ThemedText>
      <Ionicons name="navigate-circle" size={32} color={BrandColors.white} />
    </TouchableOpacity>
  );
}

const styles = StyleSheet.create({
  button: {
    flexDirection: "row",
    gap: 12,
    padding: 16,
    borderRadius: 8,
    backgroundColor: BrandColors.primary,
    justifyContent: "center",
    alignItems: "center",
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.15,
    shadowRadius: 12,
    elevation: 8,
    zIndex: 100,
  },
  label: {
    color: BrandColors.white,
    lineHeight: 20,
  },
});
